module.exports = {
      id: "hamburger-instagram-usage",
      viewBox: "0 0 38 37",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#hamburger-instagram",
      toString: function () {
        return this.url;
      }
    }